import { Extension } from "@tiptap/core";
import {
  NodeViewProps,
  NodeViewWrapper,
  ReactNodeViewRenderer,
} from "@tiptap/react";

import { SectionTitleNode as CoreSectionTitleNode } from "@nnr/tiptap-extensions";

/**
 * @deprecated This is only used in the old structured documents.
 */
const SectionTitleComponent = ({ node }: NodeViewProps) => {
  return (
    <NodeViewWrapper contentEditable={false}>
      <div className="bg-background-3 flex flex-col gap-2 p-4">
        <div className="text-lg font-bold">{node.attrs.content}</div>
        <div className="text-accent italic">
          Note: This is a deprecated legacy section component. Please remove and
          replace with regular headings.
        </div>
      </div>
    </NodeViewWrapper>
  );
};

export const SectionTitleNodeWithView = CoreSectionTitleNode.extend<Extension>({
  addNodeView() {
    return ReactNodeViewRenderer(SectionTitleComponent);
  },
});
